import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcText,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { addShipmentMethod } from 'utils/api-routes.util'
import { IPixelFactory, IShipmentMethod } from '../../../../../../decl.d'

const AddNewShipment = (props: {
  handleClose: (data: IShipmentMethod, action: string) => void
}) => {
  const { handleClose } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    description: '',
    title: '',
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()

    handleAddStatus()
  }

  const handleAddStatus = () => {
    showPageLoader()
    addShipmentMethod(data).subscribe((res) => {
      const response = res.response as {
        data?: IShipmentMethod
        error?: string
        field?: string
      }
      if (response.data) {
        showSuccess('Successfully Added')
        setData({
          title: response.data.title,
          description: response.data.description,
        })
        handleClose(response.data, 'add')
        hidePageLoader()
      } else {
        if (response.error && response.field) {
          setError({
            error: response.error,
            field: response.field,
          })
        } else {
          showFailure(response.error)
        }
        hidePageLoader()
      }
    })
  }
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox flexDirection="row" width="100%" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Title
            </DcText>
            <DcInput
              error={
                error.field === 'Title' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Title'}
              placeholder={'Title'}
              value={data.title}
              onChange={(e) => setData({ ...data, title: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox flexDirection="row" width="100%" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Description
            </DcText>
            <DcInput
              error={
                error.field === 'Description' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Description'}
              placeholder={'Description'}
              value={data.description}
              onChange={(e) =>
                setData({ ...data, description: e.target.value })
              }
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          gap="10px"
          justifyContent="flex-end"
        >
          <DcButton variant="primary" type="submit" withIcon={true} size="sm">
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default AddNewShipment
